import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Card, CardBody, CardFooter, Col, Form, Row } from 'reactstrap'
import { Input, Button } from '../Globals'
import { Auth } from 'aws-amplify'
import Modal from 'react-modal'
import nissanlogo from '../../assets/img/brand/nissan-logo.png'

const ModalNewPwd = ({ username, redirectLogin, close }) => {
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  const handleCode = async () => {
    if (password.length < 8) {
      return setError(
        'You must enter a password with 8 character minimum and one special char.'
      )
    }

    try {
      await Auth.forgotPasswordSubmit(username, code, password)
      redirectLogin()
    } catch (e) {
      setError(e.message)
    }
  }

  return (
    <Modal
      isOpen={true}
      onRequestClose={close}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <p className="close-modal" onClick={close}>
        Close<i className="fa fa-times"></i>
      </p>
      <div>
        <Form onSubmit={handleCode}>
          <p style={{ marginBottom: '10px' }}>
            A code has been sent to your mail, please register it here with your
            new Password
          </p>
          <Input
            required
            icon="icon-lock"
            type="password"
            placeHolder="New Password"
            value={password}
            change={password => setPassword(password)}
          />
          <Input
            required
            icon="icon-pin"
            type="text"
            placeHolder="Code"
            value={code}
            change={code => setCode(code)}
          />
          <Button
            class="btn-nissan-red forgot-pwd-btn"
            type="submit"
            text="Validate"
          />
          {error !== '' && <p className="error">{error}</p>}
        </Form>
      </div>
    </Modal>
  )
}

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [error, setError] = useState('')
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const handleGetCodeByMail = async () => {
    try {
      await Auth.forgotPassword(username)
      setError('')
      setModalIsOpen(true)
    } catch (e) {
      setError(e.message)
    }
  }

  const handleRedirectLogin = () => {
    navigate('/login')
  }

  const handleCloseModal = () => {
    setModalIsOpen(false)
  }

  return (
    <div className="flex-row align-items-center forgot-password">
      <div className="login-logo">
        <img src={nissanlogo} alt="Nissan Logo" />
      </div>
      <Card>
        <CardBody className="p-4">
          <Form onSubmit={handleGetCodeByMail}>
            <h1>Forgot Password</h1>
            <br />
            <Input
              required
              icon="icon-user"
              type="text"
              placeHolder="Username"
              value={username}
              change={username => setUsername(username)}
            />
            <Button
              disabled={!username}
              class="btn-nissan-red"
              type="submit"
              text="Send code by mail"
            />
            {error !== '' && <p className="error">{error}</p>}
          </Form>
        </CardBody>
        <CardFooter className="p-4">
          <Row>
            <Col xs="12">
              <p onClick={handleRedirectLogin} className="back-login">
                Return to Login
              </p>
            </Col>
          </Row>
        </CardFooter>
      </Card>
      {modalIsOpen && (
        <ModalNewPwd
          username={username}
          close={handleCloseModal}
          redirectLogin={handleRedirectLogin}
        />
      )}
    </div>
  )
}

ModalNewPwd.propTypes = {
  username: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  redirectLogin: PropTypes.func.isRequired,
}

export default ForgotPassword
